import { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import { Images } from '../../../assets/asset';
import logo from '../../../assets/images/logo-dark-mode.svg';
import { connect } from 'react-redux';
import { beforeFooter, getFooter } from './footer.action';

function Footer(props) {
    const history = useHistory();
    const pathname = history.location.pathname;
    const [settings, setSettings] = useState({
        discord: '',
        twitter: '',
        youtube: '',
        instagram: '',
        medium: '',
        telegram: '',
        reddit: '',
        github: '',
        desc: ''
    });

    useEffect(() => {
        props.getFooter()
    }, [])

    useEffect(() => {
        if (props.settings.settingsAuth) {
            setSettings(props.settings.settings)
        }
    }, [props.settings.settingsAuth])

    return (
        <div className="footer-section">
            <img src={Images.topright1} className="topright-bar-1" />
            <img src={Images.topright2} className="topright-bar-2" />
            <div className="footer-container">
                <Row className=" justify-sm-content-center">
                    <Col lg={7} md={7} sm={12}>
                        <div className="mb-3 mb-md-4">
                            <h2 className="loop-text text-center text-md-left">Stay in the loop</h2>
                            <p className="loop-desc text-center text-md-left">{settings ? settings.desc : ''}</p>
                        </div>
                    </Col>
                    <Col lg={5} md={5} sm={12}>
                        <div className="mb-3 mb-md-4">
                            <h2 className="join-text text-center text-md-right">Join the Community</h2>
                            <p className="join-desc text-center text-md-right">Join our loram ip sucnwl fakev dcvml.</p>
                        </div>
                        <div className="footer-icons">
                            <ul className="social-links list-unstyled text-center text-md-right">
                                {settings ? settings.discord && <li className="d-inline-block align-top"> <a href={settings.discord} target="_blank" ><img src={Images.discord} className="img-fluid" /></a></li> : ''}
                                {settings ? settings.twitter && <li className="d-inline-block align-top"> <a href={settings.twitter} target="_blank" ><img src={Images.twitter} className="img-fluid" /></a></li> : ''}
                                {settings ? settings.youtube && <li className="d-inline-block align-top"> <a href={settings.youtube} target="_blank"><img src={Images.youtube} className="img-fluid" /></a></li> : ''}
                                {settings ? settings.instagram && <li className="d-inline-block align-top"> <a href={settings.instagram} target="_blank" ><img src={Images.instagram} className="img-fluid" /></a> </li> : ''}
                            </ul>
                        </div>
                    </Col>
                </Row>
                {/* <Row className=" justify-sm-content-center align-items-center">
                    <Col lg={7} md={7} sm={12}>
                        <div>
                            <input type="text" placeholder="Your email address" className="footer-input-field" />
                            <a className="btn btn-outline-warning signup" href="/signup"><i className="icon-rocket mr-2" />Signup</a>
                        </div>
                    </Col>
                    <Col lg={4} md={4} sm={12}>
                        <div className="footer-icons">
                            <ul className="social-links list-unstyled">
                                {settings ? settings.discord && <li className="d-inline-block align-top"> <a href={settings.discord} target="_blank" ><img src={Images.discord} className="img-fluid" /></a></li> : ''}
                                {settings ? settings.twitter && <li className="d-inline-block align-top"> <a href={settings.twitter} target="_blank" ><img src={Images.twitter} className="img-fluid" /></a></li> : ''}
                                {settings ? settings.youtube && <li className="d-inline-block align-top"> <a href={settings.youtube} target="_blank"><img src={Images.youtube} className="img-fluid" /></a></li> : ''}
                                {settings ? settings.instagram && <li className="d-inline-block align-top"> <a href={settings.instagram} target="_blank" ><img src={Images.instagram} className="img-fluid" /></a> </li> : ''}
                            </ul>
                        </div>
                    </Col>
                </Row> */}
                {/* <div className="sponser-wrapper">
                    <div><img src={Images.blockchain} className="img-fluid" /></div>
                    <div><img src={Images.quantum} className="img-fluid" /></div>
                    <div><img src={Images.trust} className="img-fluid" /></div>
                    <div><img src={Images.coinbase} className="img-fluid" /></div>
                    <div><img src={Images.aave} className="img-fluid" /></div>
                </div> */}
                <Row className="footer-nav">
                    <Col xl={3} sm={12} className="text-center text-lg-left">
                        <div className="d-md-flex mb-3 mb-xl-0 pl-lg-0">
                            <Link to="/" className="d-inline-block align-top">
                                <img className="img-fluid" src={logo} alt="Site Logo" width="120px" />
                            </Link>
                        </div>
                    </Col>
                    <Col xl={9} sm={12} className="pr-lg-0">
                        <ul className="unorder-footer-nav">
                            <li className="footer-listing"><Link to="/">Marketplace</Link></li>
                            <li className="footer-listing"><Link to="/auctions">Live Auctions</Link></li>
                            <li className="footer-listing"><Link to="/contact">Contact</Link></li>
                            <li className="footer-listing"><Link to="/integration">Integration</Link></li>
                            <li className="footer-listing"><Link to="/authors">Top Sellers</Link></li>
                        </ul>
                    </Col>
                </Row>
                <div className="copy-right-text-wrapper">
                    <div className="copy-right-text">
                        © 2021 Imagible, All Rights Reserved.
                    </div>
                    <div className="icons-wrapper">
                        {settings ? settings.medium && <div><a href={settings.medium} target="_blank" ><img src={Images.mvector} className="img-fluid icon-pad" /></a></div> : ''}
                        {settings ? settings.telegram && <div><a href={settings.telegram} target="_blank" ><img src={Images.send} className="img-fluid icon-pad" /></a></div> : ''}
                        {settings ? settings.reddit && <div><a href={settings.reddit} target="_blank" ><img src={Images.reddit} className="img-fluid icon-pad" /></a></div> : ''}
                        {settings ? settings.github && <div><a href={settings.github} target="_blank" ><img src={Images.github} className="img-fluid icon-pad" /></a></div> : ''}
                    </div>
                </div>
            </div>
        </div>
    );
}
const mapStateToProps = state => ({
    settings: state.settings,
    error: state.error
});

export default connect(mapStateToProps, { beforeFooter, getFooter })(Footer);